import type { IPromoQuerySchema } from '../../repositories/search-offers/entities/query_for_offer_promos/PromoQuerySchema';
import {
  fetchPublicWebV1SearchOffersForNewbuildingPromos,
  IPublicWebV1SearchOffersForNewbuildingPromosResponse200,
  IPublicWebV1SearchOffersForNewbuildingPromosResponse400,
  TPublicWebV1SearchOffersForNewbuildingPromosResponse_1,
} from '../../repositories/search-offers/web/v1/search-offers-for-newbuilding-promos';
import { IApplicationContext } from '../../types/applicationContext';
import { ResponseError } from '../../utils/errors';

interface IFetchRegionMetaParameters {
  path?: string;
  subdomain: string;
  query?: IPromoQuerySchema;
}

export async function fetchPromoOffers(
  context: IApplicationContext,
  { path, subdomain, query }: IFetchRegionMetaParameters,
): Promise<TPublicWebV1SearchOffersForNewbuildingPromosResponse_1> {
  const { httpApi } = context;

  const promoOffers = await fetchPublicWebV1SearchOffersForNewbuildingPromos<
    IPublicWebV1SearchOffersForNewbuildingPromosResponse200,
    IPublicWebV1SearchOffersForNewbuildingPromosResponse400
  >({
    httpApi,
    parameters: {
      path,
      subdomain,
      query,
    },
  });

  if (promoOffers.statusCode !== 200) {
    throw new ResponseError({
      domain: 'fetchPromoOffers',
      message: promoOffers.response.message as string,
    });
  }

  return promoOffers.response;
}
